import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import LoadingSpinner from './LoadingSpinner'
import AppShell from './AppShell'
import RouteErrorBoundary from './RouteErrorBoundary'

export default function ProtectedRoute() {
  const { session, loading } = useAuth()
  const location = useLocation()

  if (loading) return <LoadingSpinner fullPage />
  if (!session) return <Navigate to="/login" state={{ from: location }} replace />

  return (
    <AppShell>
      {/* Keyed by path so navigating away from a crashed page remounts the
          boundary and clears its error state (Sentry's ErrorBoundary has no
          resetKeys prop in the installed version). */}
      <RouteErrorBoundary key={location.pathname}>
        <Outlet />
      </RouteErrorBoundary>
    </AppShell>
  )
}
